// extracted by mini-css-extract-plugin
module.exports = {"modal":"AddNewPlan_modal__2_0Bm"};